import Link from "next/link";
import Image from "next/image";
import { FaFacebook, FaInstagram, FaPinterest } from "react-icons/fa";
import { FaTelegram } from "react-icons/fa6";
import Container from "@/components/ui/Container";

export default function Footer() {
  const legalLinks = [
    { label: "Términos de servicio", href: "#" },
    { label: "Política de privacidad", href: "#" },
    { label: "Documentación", href: "#" }
  ];

  const socialLinks = [
    { icon: FaTelegram, href: "#", label: "Telegram" },
    { icon: FaPinterest, href: "#", label: "Pinterest" },
    { icon: FaInstagram, href: "#", label: "Instagram" },
    { icon: FaFacebook, href: "#", label: "Facebook" }
  ];

  return (
    <footer
      className="text-white"
      style={{
        background: "linear-gradient(0deg, rgba(52, 78, 65, 0.85) 0%, rgba(52, 78, 65, 0.85) 100%), url('/images/Bloom-Wise_footer_background.webp') lightgray 50% / cover no-repeat"
      }}
    >
      <Container>
        {/* Top Section */}
        <div style={{ padding: "30px 0 20px 0" }} className="border-b border-white/10">
          <div className="flex flex-col lg:flex-row justify-center lg:justify-between items-center gap-8">
            {/* Left - Logo and Brand */}
            <Link
              href="/"
              className="mx-auto lg:mx-0"
              style={{
                display: "flex",
                width: "234.322px",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "10px",
              }}
            >
              <Image
                src="/images/Logo-White.svg"
                alt="BloomWise"
                width={234}
                height={100}
              />
            </Link>

            {/* Right - Legal Links */}
            <div className="flex flex-wrap gap-8 justify-center lg:justify-end">
              {legalLinks.map((link, index) => (
                <Link
                  key={index}
                  href={link.href}
                  className="text-white hover:text-accent transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div style={{ padding: "20px 0" }} className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Left - Social Links */}
          <div className="flex space-x-4">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.href}
                aria-label={social.label}
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
              >
                <social.icon className="w-5 h-5" />
              </a>
            ))}
          </div>

          {/* Right - Copyright */}
          <p className="text-white/60 text-sm">
            Copyright © 2025 Bloom Wise.
          </p>
        </div>
      </Container>
    </footer>
  );
}
